export default __webpack_public_path__ + "static/media/MarDom2024.ef18fcec.png";